import React, { useRef } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { countOrACVFormatter, StyledTableRow } from '../../util/customFunctions';
import CopyTablesObjectv2 from "../../components/xlsx-export/CopyTablesObjectv2";

const useStyles = makeStyles({
  stickyHeader: {
    position: "sticky",
    left: 0,
    background: "#fff",
    zIndex: 3,
    fontWeight: "bold",
  border: "0.5px solid #ddd",
    padding: "12px 8px",
  },
  headerCell: {
    fontWeight: "bold",
    background: "#fff",
    textAlign: "center",
    padding: "12px 8px",
  border: "0.5px solid #ddd",
    position: "sticky",
    top: 0,
    zIndex: 2,
  },
  committedHeader: {
    background: "#4471c4",
    color: "white",
    textAlign: "center",
    fontWeight: "bold",
    padding: "12px 8px",
  border: "0.5px solid #ddd",
    position: "sticky",
    top: 0,
    zIndex: 2,
  },
  bestCaseIncrementalHeader: {
    background: "#5b9bd5",
    color: "white",
    textAlign: "center",
    fontWeight: "bold",
    padding: "12px 8px",
  border: "0.5px solid #ddd",
    position: "sticky",
    top: 0,
    zIndex: 2,
  },
  bestCaseTotalHeader: {
    background: "#4471c4",
    color: "white",
    textAlign: "center",
    fontWeight: "bold",
    padding: "12px 8px",
  border: "0.5px solid #ddd",
    position: "sticky",
    top: 0,
    zIndex: 2,
  },
  subHeaderCell: {
    textAlign: "center",
    padding: "5px 8px",
    fontWeight: 600,
    background: "#fff",
  border: "0.5px solid #ddd",
    position: "sticky",
    top: 47,
    zIndex: 2,
    width: '100px'
  },
  dataCell: {
    textAlign: "right",
    padding: "5px 8px",
  border: "0.5px solid #ddd",
  },
  repCell: {
    position: "sticky",
    left: 0,
    // background: "#fff",
    fontWeight: 600,
    zIndex: 1,
  border: "0.5px solid #ddd",
    padding: "5px 8px",
  },
});

// ... data array remains the same

const formatCurrency = (num) =>
  num ? countOrACVFormatter(num, true) : "-";

const formatCurrencyJudgement = (num) =>
  num ? countOrACVFormatter(num, true) : countOrACVFormatter(0, true);

const ForecastByRepTable = ({data=[]}) => {
  const classes = useStyles();
  const tableRef = useRef();

  return (
    <Box >
      {/* Copy Button */}
      <div style={{ textAlign: 'right', marginBottom: '8px' }}>
        <CopyTablesObjectv2 tableRef={tableRef} />
      </div>

      <TableContainer
        component={Paper}
        style={{
          maxHeight: '60vh',
          borderRadius: 0,
          overflowX: "auto",
        // border: "0.5px solid #ddd",
        }}
      >
        <Table ref={tableRef} stickyHeader style={{ borderCollapse: 'collapse' }}>
          <TableHead>
            {/* First Header Row */}
            <TableRow>
              <TableCell rowSpan={2} className={classes.stickyHeader} align='center' style={{width: '150px'}}>
                Rep
              </TableCell>
              <TableCell rowSpan={2} className={classes.headerCell} style={{width: '100px'}}>
                Already Won
              </TableCell>
              <TableCell rowSpan={2} className={classes.headerCell} style={{width: '100px'}}>
                Quota
              </TableCell>
              <TableCell colSpan={4} className={classes.committedHeader}>
                Commit
              </TableCell>
              <TableCell colSpan={2} className={classes.bestCaseIncrementalHeader}>
                Best Case Incremental
              </TableCell>
              <TableCell colSpan={2} className={classes.bestCaseTotalHeader}>
                Best Case Total
              </TableCell>
            </TableRow>

            {/* Second Header Row */}
            <TableRow>
              {/* Committed Sub-headers */}
              <TableCell className={classes.subHeaderCell}>
                From Specific Opps
              </TableCell>
              <TableCell className={classes.subHeaderCell}>
                Judgement
              </TableCell>
              <TableCell className={classes.subHeaderCell}>
                Total
              </TableCell>
              <TableCell className={classes.subHeaderCell}>
                % of Quota
              </TableCell>

              {/* Best Case Incremental Sub-headers */}
              <TableCell className={classes.subHeaderCell}>
                From Specific Opps
              </TableCell>
              <TableCell className={classes.subHeaderCell}>
                Judgement
              </TableCell>

              {/* Best Case Total Sub-headers */}
              <TableCell className={classes.subHeaderCell}>
                Total
              </TableCell>
              <TableCell className={classes.subHeaderCell}>
                % of Quota
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {data.map((row, idx) => (
              <StyledTableRow key={idx}>
                <TableCell className={classes.repCell}>
                  {row.Rep}
                </TableCell>
                <TableCell className={classes.dataCell}>
                  {formatCurrency(row.Already_Won)}
                </TableCell>
                <TableCell className={classes.dataCell}>
                  {formatCurrency(row.Quota)}
                </TableCell>

                {/* Committed */}
                <TableCell className={classes.dataCell}>
                  {formatCurrency(row.Committed.From_Specific_Opps)}
                </TableCell>
                <TableCell className={classes.dataCell}>
                  {formatCurrencyJudgement(row.Committed.Judgement)}
                </TableCell>
                <TableCell className={classes.dataCell}>
                  {formatCurrency(row.Committed.Total)}
                </TableCell>
                <TableCell className={classes.dataCell}>
                  {Math.round(row.Committed.Percent_of_Quota * 100)}%
                </TableCell>

                {/* Best Case Incremental */}
                <TableCell className={classes.dataCell}>
                  {formatCurrency(row.Best_Case_Incremental.From_Specific_Opps)}
                </TableCell>
                <TableCell className={classes.dataCell}>
                  {formatCurrencyJudgement(row.Best_Case_Incremental.Judgement)}
                </TableCell>

                {/* Best Case Total */}
                <TableCell className={classes.dataCell}>
                  {formatCurrency(row.Best_Case_Total.Total)}
                </TableCell>
                <TableCell className={classes.dataCell}>
                  {Math.round(row.Best_Case_Total.Percent_of_Quota * 100)}%
                </TableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ForecastByRepTable;